import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import DealApp from '../components/DealApp.tsx';
import '../styles.css';

const App = () => {
  return <DealApp />;
};

document.addEventListener('DOMContentLoaded', () => {
  const rootElement = document.getElementById('react-root');
  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(
      <StrictMode>
        <App />
      </StrictMode>
    );
  }
});
